import { useEffect, useState } from "react";
export function useReportTabSync(tabs, initialTabId, onTabChange) {
    const getTabIndexFromId = (id) => {
        if (!id) return 0;
        const idx = tabs.findIndex((tab) => tab.id === id);
        return idx >= 0 ? idx + 1 : 0;
    };
    const getTabIdFromIndex = (idx) => {
        if (idx === 0) return null;
        return tabs[idx - 1]?.id;
    };

    const [tabIndex, setTabIndex] = useState(() => getTabIndexFromId(initialTabId));

    useEffect(() => {
        setTabIndex(getTabIndexFromId(initialTabId));
        // eslint-disable-next-line
    }, [initialTabId, tabs]);

    const handleTabChange = (event, newIndex) => {
        setTabIndex(newIndex);
        if (onTabChange) onTabChange(getTabIdFromIndex(newIndex));
    };

    return {
        tabIndex,
        setTabIndex,
        handleTabChange,
        getTabIdFromIndex,
        getTabIndexFromId
    };
}